<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">사용매출</span>
      <button class="btn-pop-close" @click="$.emit('close')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset">
        <span class="h2">결제금액</span>
        <div class="ip-row">
          <label for="payAmount">결제금액</label>
          <input
            type="text"
            class="ip-comm"
            id="payAmount"
            :value="totalCash.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          />
        </div>
      </div>
    </div>
  </div>
  <PopupBtn2
    v-if="isPopupBtn2"
    :popupText="popupText"
    :popupTitle="popupTitle"
    @close="
      isPopupBtn2 = false;
      $.emit('close');
    "
    @setYes="setYes"
  />
</template>

<script>
import popupBtn2 from "@/components/popup/PopupBtn2.vue";
export default {
  name: "useSale",
  props: {
    totalUprc: Number,
    totalDiscount: Number,
    receivedUprc: Number,
    payType: String,
  },
  data() {
    return {
      isPopupBtn2: true,
      popupText: "사용매출 처리 하시겠습니까?",
      popupTitle: "사용매출",
      totalCash: this.totalUprc - this.totalDiscount - this.receivedUprc,
    };
  },
  methods: {
    setYes() {
      this.isPopupBtn2 = false;
      this.payInUseSale();
    },
    loadingPromise(text) {
      this.$.emit("openLoading", text);
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$.emit("closeLoading");
          resolve(1);
        }, 1000);
      });
    },
    async payInUseSale() {
      await this.loadingPromise("결제완료 처리 중입니다.");
      await this.loadingPromise("영수증 출력 중입니다.");
      this.$.emit("resetBasket", this.payType);
      this.$.emit("close");
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {
    PopupBtn2: popupBtn2,
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped>
canvas {
  border: 1px solid #000;
}
</style>


